export enum Profile {
  SINGER = "singer",
  GUITAR = "guitar",
}
